import InfoCard from './InfoCard'
import OhSnapSvg from '../assets/OhSnap.svg'

function OhSnap() {
  return (
    <InfoCard
      title="Oh Snap!"
      description="Something went wrong! We are working hard to fix this. Please come back later."
    >
      <OhSnapSvg />
    </InfoCard>
  )
}

export default OhSnap
